import { createActionCreator } from 'deox';
import { ServiceCatalogue, Paging } from '@/types';
import { ServiceForm } from '@/services/service-directory/service-catalogue';

export const fetchServicesActions = {
  request: createActionCreator(
    'FETCH_SERVICES_REQUEST',
    (resolve) => (
      entityId: string,
      pageNumber?: number,
      pageSize?: number,
      searchText?: string,
      loadingMore?: boolean
    ) => resolve({ entityId, pageNumber, pageSize, searchText, loadingMore })
  ),
  success: createActionCreator(
    'FETCH_SERVICES_SUCCESS',
    (resolve) => (data: ServiceCatalogue[], paging: Paging, loadingMore?: boolean) =>
      resolve({ data, paging, loadingMore })
  ),
  failure: createActionCreator('FETCH_SERVICES_FAILURE', (resolve) => (error: Error) => resolve({ error })),
};

export const fetchServiceByIdActions = {
  request: createActionCreator('FETCH_SERVICE_REQUEST', (resolve) => (entityId: string, id: string) =>
    resolve({ entityId, id })
  ),
  success: createActionCreator('FETCH_SERVICE_SUCCESS', (resolve) => (service: ServiceCatalogue) => resolve(service)),
  failure: createActionCreator('FETCH_SERVICE_FAILURE', (resolve) => (error: Error) => resolve({ error })),
};

export const createServiceActions = {
  request: createActionCreator('CREATE_SERVICE_REQUEST', (resolve) => (entityId: string, service: ServiceForm) =>
    resolve({ entityId, service })
  ),
  success: createActionCreator('CREATE_SERVICE_SUCCESS'),
  failure: createActionCreator('CREATE_SERVICE_FAILURE', (resolve) => (error: Error) => resolve({ error })),
};

export const editServiceActions = {
  request: createActionCreator(
    'EDIT_SERVICE_REQUEST',
    (resolve) => (entityId: string, id: string, service: ServiceForm) => resolve({ entityId, id, service })
  ),
  success: createActionCreator('EDIT_SERVICE_SUCCESS'),
  failure: createActionCreator('EDIT_SERVICE_FAILURE', (resolve) => (error: Error) => resolve({ error })),
};

export const deleteServiceActions = {
  request: createActionCreator('DELETE_SERVICE_REQUEST', (resolve) => (entityId: string, id: string) =>
    resolve({ entityId, id })
  ),
  success: createActionCreator('DELETE_SERVICE_SUCCESS'),
  failure: createActionCreator('DELETE_SERVICE_FAILURE', (resolve) => (error: Error) => resolve({ error })),
};
